import React, { Component } from 'react';

import { isMobileDevice } from "../../utils/DeviceDetector.js";
const isMobile = isMobileDevice();
import './BottomMenuBarSlider.css';
import "slick-carousel/slick/slick.css";
import Slider from "react-slick";
import { withTranslation } from 'react-i18next';
import { AppContext } from '../../AppContext.jsx';
import { ThreeJSWorldContext } from 'web-store-modules/packages/web-store-three-world';
import I18NextContext from './i18next-context/I18NextContext.jsx';
import { getAllSceneInfoDictAsync } from '../../utils/StoreConfigManager.js';
import { BottomBarMenuClicked, StoreSelectorOption } from '../../utils/Analytics.js';


const linkedRandomScenes = (props) => { 
    return [   
    {
        name: props.t('sectionMenuScene2'),
        image: 'https://cdn.obsess-vr.com/ferragamo/Music.png',
        scene_id: '614a6aa5d7bb008cbec58ca9'
    },
    {
        name: props.t('sectionMenuScene3'),
        scene_id: '614a6a668135ae99e7eb653e',
        image: 'https://cdn.obsess-vr.com/ferragamo/Library.png'
    },
    {
        name: props.t('sectionMenuScene4'),
        scene_id: '614b3e16d7bb008cbec58cb6',
        image: 'https://cdn.obsess-vr.com/ferragamo/Dining.png'
    },
    {
        name: props.t('sectionMenuScene5'),
        image: 'https://cdn.obsess-vr.com/ferragamo/Movie.png',
        scene_id: '614c8c355d0a6b36fe5ab366'
    },
]
}
class BottomMenuBarSlider extends Component {
    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    bottomMenuBarItems = () => {
        const routeRendersRandom = linkedRandomScenes(this.props).map((scene, index) => (
            <React.Fragment key={scene.scene_id}>
                <div>
                    <div className='footer-nav' onClick={()=> this.onClick(scene.scene_id)} > 
                        <img src={scene.image} alt="scenes"/> 
                        <span>{scene.name}</span>
                    </div>
                </div>
            </React.Fragment>
        ));
        return routeRendersRandom;
    }

    onClick(sceneId) {
        const { threeJSWorldContext, setLoadingIconVisibility } = this.props;
        setLoadingIconVisibility(true);
        getAllSceneInfoDictAsync()
            .then(sceneInfoDict => {
                if (!sceneInfoDict[sceneId]) {
                    throw new Error('Scene with id ' + sceneId + ' do not exist!');
                }

                const linkedSceneName = sceneInfoDict[sceneId]['name'];
                let targetPath = `/${this.props.currentLanguage}/${linkedSceneName}`;
                StoreSelectorOption(linkedSceneName);
                BottomBarMenuClicked(linkedSceneName);

                if (threeJSWorldContext.history.location.pathname !== targetPath) {
                    threeJSWorldContext.pushHistoryWithReset(targetPath)
                } else {
                    setLoadingIconVisibility(false);
                }
            })
    }

    render() {
        const slidesToShow = isMobile ? 3 : 4;
        const slidesToScroll2 = isMobile ? 3 : 1;
        const variableWidth = isMobile ? false : true;
        const infiniteLoop = isMobile ? true : false;

        const sliderSettings = {
            infinite: false,
            centerMode: false,
            speed: 500,
            centerPadding: '0px',
            slidesToShow: slidesToShow,
            slidesToScroll: slidesToScroll2,
            transformEnabled: false,
            variableWidth: variableWidth,
            arrows: infiniteLoop
          };


        return (
            <div className="sl-slider">
                <Slider {...sliderSettings}>
                    {this.bottomMenuBarItems()}
                </Slider>
            </div>
        );
    }
}

//export default BottomMenuBarSlider;

export default withTranslation()(props => (
    <AppContext.Consumer>
    {appContextValue => (
        <ThreeJSWorldContext.Consumer>
            {threeJSWorldContext => (
                <I18NextContext.Consumer>
                    {i18Props => (
                        <BottomMenuBarSlider
                            {...props}
                            setLoadingIconVisibility={appContextValue.setLoadingIconVisibility}
                            threeJSWorldContext={threeJSWorldContext}
                            currentLanguage={i18Props.currentLanguage}
                        />
                    )}
                </I18NextContext.Consumer>
            )}
        </ThreeJSWorldContext.Consumer>
     )}
     </AppContext.Consumer>
));
